module.exports = __webpack_public_path__ + "img/light_logoPixabay.a2993027.png";